export default __webpack_public_path__ + "static/blue-5b2d7467cc94965e1be9e02b970959a6.png";